import React from 'react';
import { Checkbox } from '@clearcover/atlas';
import { BlockListRow } from 'BlockList/types';

type ActiveCellProps = {
  row: BlockListRow;
  onDeactivate: (row: BlockListRow) => void;
};

export const ActiveCell: React.FC<ActiveCellProps> = ({
  row,
  onDeactivate,
}) => {
  const isActive = row.active;

  return (
    <Checkbox
      label="Active"
      name={`active-${row.id}`}
      value={isActive}
      toggle
      hideLabel
      disabled={!isActive}
      onChange={() => {
        if (isActive) {
          onDeactivate(row);
        }
      }}
    />
  );
};
